var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDragHandleDots2 = function SvgDragHandleDots2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillOpacity: 0.01,
    d: "M0 0h16v16H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#8B8D98",
    fillRule: "evenodd",
    d: "M5.867 4.933a1.2 1.2 0 1 0 0-2.4 1.2 1.2 0 0 0 0 2.4m4.266 0a1.2 1.2 0 1 0 0-2.4 1.2 1.2 0 0 0 0 2.4M11.333 8a1.2 1.2 0 1 1-2.4 0 1.2 1.2 0 0 1 2.4 0M5.867 9.2a1.2 1.2 0 1 0 0-2.4 1.2 1.2 0 0 0 0 2.4m5.466 3.067a1.2 1.2 0 1 1-2.4 0 1.2 1.2 0 0 1 2.4 0m-5.466 1.2a1.2 1.2 0 1 0 0-2.4 1.2 1.2 0 0 0 0 2.4",
    clipRule: "evenodd"
  })));
};
export default SvgDragHandleDots2;